import { Maybe } from "@sp-crm/core";
import * as React from "react";
import { useFeature } from "store/selectors/hooks";
import { ReportsV2 } from "../reports-v2";
import * as ReportConstants from "./constants";
import { ReportsNavigation } from "./navigation";
import { ReportsShow } from "./show";

interface ReportsProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    children: any;
    match?: {
        params?: {
            reportname: string;
        };
    };
}

export const Reports: React.FC<ReportsProps> = props => {
    const reportsV2Enabled = useFeature("reportsV2");

    const currentReport = (): ReportConstants.ReportNames => {
        return Maybe.fromValue(props)
            .map(p => p.match)
            .map(m => m.params)
            .map(p => p.reportname)
            .getOrElse("summary") as ReportConstants.ReportNames;
    };

    const reportName = currentReport();

    if (reportsV2Enabled && reportName === "summary") {
        return (
            <>
                <ReportsNavigation />
                <ReportsV2 />
            </>
        );
    }

    return (
        <>
            <ReportsNavigation />
            <ReportsShow reportName={reportName} />
        </>
    );
};
